export type HubManagerTabId =
  | "explorer"
  | "subscriptions"
  | "myCatalogs"
  | "reviews";

export const DEFAULT_HUB_MANAGER_TAB: HubManagerTabId = "explorer";

export function isHubManagerTabParam(
  value: string | null,
): value is HubManagerTabId {
  return (
    value === "explorer" ||
    value === "subscriptions" ||
    value === "myCatalogs" ||
    value === "reviews"
  );
}

export function parseHubManagerTabParam(
  value: string | null,
): HubManagerTabId | null {
  if (value == null || value === "") return null;
  return isHubManagerTabParam(value) ? value : null;
}
